import React from "react";
import {
    buildRow,
    getLabel,
    parseDate
} from "../../util/FormatUtil";
import Select from "react-select";
import PodSched, {PodBreak} from "../../types/PodSched";
import {isEmptyObject} from "jquery";
import moment from "moment";
import DatePicker from 'react-datepicker';
import {sweetalert} from "../../App";
import Validator from "../../validation/Validator";
import {Validators} from "../../validation/Validators";
import AdminAPI from "../../network/AdminAPI";
import {CustomFieldBuilder} from "../../customfields/CustomFieldBuilder";
import GetField from "../../customfields/GetField";


interface PodModalProps{
    selectedPod
    facilties
    schedule
    services
    onSubmit:(pod:PodSched, podBreaks:PodBreak[]) => void
    pageCustomQuestions?
}

interface PodModalState{
    selectedPod?
    pods?
    podID?
    facility?
    isActive?
    service?
    isPrivate?
    accessCode?
    date?
    startTime?
    endTime?
    nickName?
    breaks:{StartTime:Date, EndTime:Date}[]
    breakStartSelector?
    breakEndSelector?
    factor?
    allPods?:{label:string,value:number}[]
    podLabel?
    customFieldData?
    createdDate?
    hasAppts?:boolean
    breakChanged?
    podDataChanged?

}

export class PodManagementModal extends React.Component<PodModalProps, PodModalState>{
    public static ID = "podedit"

    constructor(props) {
        super(props);
        this.state = {hasAppts: false, breaks:[], breakEndSelector:"", breakStartSelector:"", accessCode:"", nickName:"", customFieldData: null};
        this.deleteBreak = this.deleteBreak.bind(this);
        this.newBreak = this.newBreak.bind(this);
        this.isBreakValid = this.isBreakValid.bind(this);
        this.isOverlapping = this.isOverlapping.bind(this)
        this.breaksOverlapping = this.breaksOverlapping.bind(this);
        this.removeFieldFromPopUp = this.removeFieldFromPopUp.bind(this);
        //this.doesPodConflictWithBreak = this.doesPodConflictWithBreak(this);
    }

    getBoolSelect(val){
        return val === 1 ? {label:"Yes", value:true} : {label:"No", value:false}
    }
    minutesOfDay(m){
        return m.minutes() + m.hours() * 60;
    }

    //Is break overlapping with existing appointment?
    isOverlapping(){
        
        let date = new Date();
        let factor = this.state.factor
        let slicedDate = date.toString().slice(0, 15);
        let doesOverlap = 0;
        
        //B is Break
        let BStart = Date.parse(this.state.breakStartSelector);
        let BEnd = Date.parse(this.state.breakEndSelector);
        if(this.state.pods[this.props.selectedPod.ID]?.times.length === 0){
            return true;
        }
        this.state.pods[this.props.selectedPod.ID]?.times.forEach((element, index) => {
            let time = element.time.slice(0, 5);
            let endTime = element.time.slice(0, 3);
            let endNum = (parseInt(time.slice(3, 5)) + 5 ).toString()
            if(endNum === '60'){
                let hour = (parseInt(endTime.slice(0, 2)) + 1).toString()
                endTime = hour + ":";
            } else {
                
            }
            let period = element.time.slice(6);
            let AStart = slicedDate + " " + time + ':00 GMT-0600 (Central Standard Time)' ;
            let AEnd = slicedDate + " " + endTime + endNum + ':00 GMT-0600 (Central Standard Time)';
            let AStartDate = Date.parse(AStart)
            let AEndDate = Date.parse(AEnd)


            if(BStart <= AStartDate && BEnd >= AStartDate && element.remaining < factor){
                doesOverlap = 1
            } else if(BEnd >= AEndDate && BStart < AEndDate && element.remaining < factor){
                doesOverlap = 1
            } else if(BStart >= AStartDate && BEnd <= AEndDate && element.remaining < factor){
                doesOverlap = 1
            }
            
        })
        if(doesOverlap === 1){
            return true;
        } else {
            return false;
        }
    }

    //Is break overlapping with another break?
    breaksOverlapping(){

        let doesOverlap = 0;
        
        //B is Break
        let newBStart = Date.parse(this.state.breakStartSelector);
        let newBEnd = Date.parse(this.state.breakEndSelector);
        
        if(this.state.breaks.length === 0){
            return false;
        }
        if(this.state.breakChanged){
        this.state.breaks?.forEach((element, index) => {
            let startTime = element.StartTime.toString();
            let endTime = element.EndTime.toString();
            let oldBStartDate = Date.parse(startTime);
            let oldBEndDate = Date.parse(endTime);



            if(newBStart <= oldBStartDate && newBEnd >= oldBStartDate){
                doesOverlap = 1
            } else if(newBEnd >= oldBEndDate && newBStart < oldBEndDate){
                doesOverlap = 1
            } else if(newBStart >= oldBStartDate && newBEnd <= oldBEndDate){
                doesOverlap = 1
            }
            
        })}
        if(doesOverlap === 1){
            return true;
        } else {
            return false;
        }
    }

    isBreakValid(podBreak:PodBreak){
        if(this.props.selectedPod && this.isOverlapping()){
            sweetalert.fire({icon: 'error', title: '', text: "Break time conflicts with scheduled appointments!"});
            return false;            
        }
        if(this.breaksOverlapping()){
            sweetalert.fire({icon: 'error', title: '', text: "Break time conflicts already scheduled break!"});
            return false;  
        }
        if(!podBreak.StartTime || !podBreak.EndTime){
            sweetalert.fire({icon: 'error', title: '', text: "Start and end time must be completed"});
            return false;
        }
        let startMoment = this.minutesOfDay(moment(podBreak.StartTime));
        let endMoment = this.minutesOfDay(moment(podBreak.EndTime));

        if(startMoment > endMoment){
            sweetalert.fire({icon: 'error', title: '', text: "Break start time cannot be after break end time"});
            return false;
        }
        let podEndMoment = this.minutesOfDay(moment(this.state.endTime));
        let podStartMoment = this.minutesOfDay(moment(this.state.startTime));
        if(endMoment > podEndMoment){
            sweetalert.fire({icon: 'error', title: '', text: "Breaks must end before schedule ends"});
            return false;
        }
        if(startMoment < podStartMoment){
            sweetalert.fire({icon: 'error', title: '', text: "Breaks must start after a schedule starts"});
            return false;
        }
        
        return true;
    }

    componentDidMount() {
        AdminAPI.getAllPods(false, false).then(response => {
            if(!response.success){
                sweetalert.fire("Error loading Pods");
            }

            this.setState({allPods: response.data as { label:string, value: number}[]})
        })

    }




    componentWillReceiveProps(nextProps: Readonly<PodModalProps>, nextContext: any) {

        if(!isEmptyObject(nextProps.selectedPod)){
            let pod:PodSched = nextProps.selectedPod;

            let services = []
            if(pod.ServiceIDs){
                let serviceIDs = JSON.parse(pod.ServiceIDs)
                if(serviceIDs.length > 0)
                serviceIDs.map(s => {
                    services.push(getLabel(s, this.props.services))
                })
            } 
            let facility = this.props.facilties.find(f => f.value === pod.FacilityID);
            let podLabel = this.state.allPods.find(f => f.value === pod.ID);
            let pods = {};
            this.props.schedule[pod.FacilityID] ? this.props.schedule[pod.FacilityID].days.forEach((element, index) => {
                    pods[element.schedID] = element
            }) : pods = {};
            let breaks:PodBreak[] = [];
            for(const podBreak of pod["PodBreaks"] as PodBreak[]){
                breaks.push({StartTime:moment(podBreak.StartTime, "HH:mm:ss").toDate() , EndTime: moment(podBreak.EndTime, "HH:mm:ss").toDate()})
            }
            this.setState({
                selectedPod:{
                    podID:pod.ID,
                    facility:facility ? facility : "",
                    isActive:this.getBoolSelect(pod.Active),
                    accessCode:pod.AccessCode,
                    services: services,
                    isPrivate:this.getBoolSelect(pod.Private),
                    date:parseDate(pod.TestDate),
                    startTime:moment(pod.StartTime, "HH:mm:ss").toDate(),
                    endTime:moment(pod.EndTime, "HH:mm:ss").toDate(),
                    nickName:pod.Nickname ? pod.Nickname : "",
                    breaks:breaks ? breaks : [],
                    breakStartSelector:"",
                    breakEndSelector:"",
                    factor:pod.Factor ? pod.Factor : 0,
                    podLabel: podLabel ? podLabel?.label : "",
                    CustomFieldData: nextProps.selectedPod && nextProps.selectedPod.CustomFieldData ? JSON.parse(nextProps.selectedPod.CustomFieldData) : null,
                    createdDate: pod.CreatedDate ? pod.CreatedDate : null,
                },
                hasAppts: pod.Booked > 0 ? true : false,
                pods: pods,
                podID:pod.ID,
                facility:facility ? facility : "",
                isActive:this.getBoolSelect(pod.Active),
                accessCode:pod.AccessCode,
                service:services,
                isPrivate:this.getBoolSelect(pod.Private),
                date:parseDate(pod.TestDate),
                startTime:moment(pod.StartTime, "HH:mm:ss").toDate(),
                endTime:moment(pod.EndTime, "HH:mm:ss").toDate(),
                nickName:pod.Nickname ? pod.Nickname : "",
                breaks:breaks ? breaks : [],
                breakStartSelector:"",
                breakEndSelector:"",
                factor:pod.Factor ? pod.Factor : 0,
                podLabel: podLabel.label,
                customFieldData: pod && pod.CustomFieldData ? JSON.parse(pod.CustomFieldData) : null,
                createdDate: pod.CreatedDate ? pod.CreatedDate : null,
                breakChanged: 0,
                podDataChanged: []
            })
        }else{
            this.setState({
                selectedPod: {},
                podID:-1,
                facility:"",
                accessCode:"",
                isActive:"",
                service:null,
                isPrivate:"",
                date:"",
                startTime:"",
                endTime:"",
                nickName:"",
                breaks:[],
                breakStartSelector:"",
                breakEndSelector:"",
                factor:"",
                customFieldData: null,
                createdDate: new Date(),
                breakChanged: 0,
                podDataChanged: [],
                hasAppts: false
            })
        }
    }

    newBreak(){
        let breaks:PodBreak[] = JSON.parse(JSON.stringify(this.state.breaks));
        let now = moment().utc().startOf('day').toDate()
        let podDate;


        if(this.props.selectedPod){
            podDate = moment(this.props.selectedPod.TestDate).utc().startOf('day').toDate()
        }
        if(this.props.selectedPod === null || podDate >= now){
            if(!this.isBreakValid({StartTime:this.state.breakStartSelector, EndTime:this.state.breakEndSelector})){
                return;
            }
        } else {
            sweetalert.fire({icon: 'error', title: '', text: "You can't schedule a break for a Pod in the past!"});
            return;
        }
        this.setState({
                        breakChanged: 0,
                    })
        if(!this.state.podDataChanged.includes('Added Break')){
            this.setState({podDataChanged: [...this.state.podDataChanged, 'Added Break']})
        }
        breaks.push({StartTime:JSON.parse(JSON.stringify(this.state.breakStartSelector)), EndTime:JSON.parse(JSON.stringify(this.state.breakEndSelector))})
        this.setState({breaks:breaks});
    }

    deleteBreak(index){
        let breaks:PodBreak[] = JSON.parse(JSON.stringify(this.state.breaks));
        breaks.splice(index, 1);
        this.setState({breaks:breaks});
    }
    public static display(){
        window["$"]("#" + PodManagementModal.ID).modal('show');
    }

    doesPodConflictWithBreak(value, state){

        let doesConflict = 0;
        
            this.state.breaks?.forEach((element, index) => {
                
                let startTime = new Date(element.StartTime);
                let endTime = new Date(element.EndTime);
                //console.log(value.toUTCString(), startTime.toUTCString(), endTime.toUTCString(), state)
                if(state === 'startTime'){
                    if(Date.parse(value.toUTCString()) > Date.parse(JSON.parse(JSON.stringify(startTime.toUTCString())))){
                        doesConflict = 1;
                    }
                }
                if(state === 'endTime'){
                    if(Date.parse(value.toUTCString()) < Date.parse(JSON.parse(JSON.stringify(endTime.toUTCString())))){
                        doesConflict = 1;
                    }
                }
            })
            //console.log(value);
            return doesConflict;
        }
    

    handleDateOnChange(value, state){
        if(state === 'startTime' || state === 'endTime'){
            if(state === 'startTime' && this.doesPodConflictWithBreak(value, state)){
                sweetalert.fire({icon: 'error', title: '', text: "Pods can not start after the start of a break."});
            }
            if(state === 'endTime' && this.doesPodConflictWithBreak(value, state)){
                sweetalert.fire({icon: 'error', title: '', text: "Pods can not end before the end of a break."});
            }
        }
        if (value) {
            this.setState({[state]: value } as any);
        }
        else{
            this.setState({[state]: null} as any)
        }
    }

    getServicesDisplayValue(){
        let servicesLabelArray = []
        this.state.service.map(s => {
            servicesLabelArray.push(s.label)
        })
        return servicesLabelArray.join(', ')
    }

    removeFieldFromPopUp(field){
        if(this.state.podDataChanged.includes(field)){
            const index = this.state.podDataChanged.indexOf(field);
            this.state.podDataChanged.splice(index, 1);
            return;
        }
        return;
    }

    render() {
        return  <div className="modal fade form_modal" id={PodManagementModal.ID} tabIndex={-1} role="dialog"
                     aria-labelledby="result_modal_label"
                     aria-hidden="true">
            <div className="modal-dialog modal-lg modal-xl" role="document" style={{display: 'block'}}>
                <div className="modal-content">
                <div className="container-fluid">
                    <div className="modal-header">
                        <h5 className="modal-title" id="result_modal_label">Schedule Editing</h5>
                        <button style={{outline: 'none'}}  type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body my-0 mx-3">
                        {this.state.podID !== -1 &&
                        buildRow("Schedule",
                            <input
                            className="form-control"
                            autoComplete="off"
                            disabled={true}
                            value={this.state.podLabel}
                            />)
                        }

                        {this.state.hasAppts ? 
                            buildRow("Facility",
                                <input
                                className="form-control"
                                autoComplete="off"
                                disabled={true}
                                value={this.state.facility.label}
                            />)
                            :
                            buildRow("Facility",
                            <Select
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                value={this.state.facility}
                                onChange={(e) => {
                                    this.setState({facility: e})
                                    if(e.value === this.props.selectedPod?.FacilityID){
                                        this.removeFieldFromPopUp("Facility")
                                    } else if(!this.state.podDataChanged.includes('Facility')){
                                       this.setState({podDataChanged: [...this.state.podDataChanged, 'Facility']})
                                    }
                                }}
                                className={"state_select"}
                                options={this.props.facilties}
                                isDisabled={this.state.hasAppts}
                            />)
                        }

                        {
                            buildRow("Is Active?",
                            <Select
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                value={this.state.isActive}
                                onChange={(e) => {
                                    this.setState({isActive: e})
                                    if(e.value ? 1 : 0 === this.props.selectedPod?.Active){
                                        this.removeFieldFromPopUp("Is Active")
                                    } else if(!this.state.podDataChanged.includes('Is Active')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'Is Active']})
                                    }
                            }}
                                className={"state_select"}
                                options={[{label: "Yes", value: true}, {label: "No", value: false}]}
                            />)
                        }



                        {buildRow("Appointments Per 5 Minutes",
                            <input  className="form-control"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        this.setState({factor:e.target.value})
                                        if(e.target.value == this.props.selectedPod?.Factor){
                                            this.removeFieldFromPopUp("Appointments Per 5 Minutes")
                                        } else if(!this.state.podDataChanged.includes('Appointments Per 5 Minutes')){
                                            this.setState({podDataChanged: [...this.state.podDataChanged, 'Appointments Per 5 Minutes']})
                                        }
                                }}
                                    value={this.state.factor}
                                    pattern={'[0-9]'}
                                    min={0}
                                    max={100}
                                    disabled={this.state.hasAppts}
                            />)
                        }
                        {this.state.hasAppts ? 
                            buildRow("Service Types",
                                <input
                                className="form-control"
                                autoComplete="off"
                                disabled={true}
                                value={this.getServicesDisplayValue()}
                            />)
                            :
                            buildRow("Service Types",
                            <Select
                                isMulti={true}
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                value={this.state.service}
                                onChange={(e) => {
                                    console.error(e)
                                    let mappedArray;
                                    if(e !== null){
                                    mappedArray = e.map(elem => {
                                        return elem.value
                                    })
                                    }
                                    this.setState({service: e})
                                    if(JSON.stringify(mappedArray) === this.props.selectedPod?.ServiceIDs){
                                        this.removeFieldFromPopUp("Service Types")
                                    } else if(!this.state.podDataChanged.includes('Service Types')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'Service Types']})
                                    }
                                }}
                                className={"state_select"}
                                options={this.props.services}
                            />)
                        }

                        {this.state.hasAppts ? 
                            buildRow("Is Private?",
                                <input
                                className="form-control"
                                autoComplete="off"
                                disabled={true}
                                value={this.state.isPrivate.label}
                            />)
                            :
                            buildRow("Is Private?",
                            <Select
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                value={this.state.isPrivate}
                                onChange={(e) => {
                                    this.setState({isPrivate: e})
                                    if(e.value == this.props.selectedPod?.Private){
                                        this.removeFieldFromPopUp("Is Private")
                                    } else if(!this.state.podDataChanged.includes('Is Private')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'Is Private']})
                                    }
                                }}
                                className={"state_select"}
                                options={[{label: "Yes", value: true}, {label: "No", value: false}]}
                                isDisabled={this.state.hasAppts}
                            />)
                        }


                        {buildRow("Access Code",
                            <input  className="form-control"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        this.setState({accessCode:e.target.value})
                                        if(e.target.value == this.props.selectedPod?.AccessCode){
                                            this.removeFieldFromPopUp("Access Code")
                                        } else if(!this.state.podDataChanged.includes('Access Code')){
                                            this.setState({podDataChanged: [...this.state.podDataChanged, 'Access Code']})
                                        }
                                    }}
                                    value={this.state.accessCode}
                                    maxLength={200}
                                    disabled={this.state.isPrivate && !this.state.isPrivate.value}
                            />)
                        }
                        {buildRow("Date",
                            <DatePicker
                                minDate={new Date('01-01-1000')}
                                maxDate={new Date('12-31-9999')}
                                placeholderText="--/--/----"
                                selected={this.state.date ? Date.parse(moment(this.state.date, 'MM-DD-YYYY').toISOString()) : null}
                                onChange={(e) => {
                                    this.handleDateOnChange(e, 'date')
                                    if(this.props.selectedPod?.TestDate.includes(moment(e).format("YYYY-MM-DD"))){
                                        this.removeFieldFromPopUp("Date")
                                    } else if(!this.state.podDataChanged.includes('Date')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'Date']})
                                    }
                                }}
                                disabled={this.state.hasAppts}
                            />
                        )}
                        {buildRow("Start Time",
                            <DatePicker
                                placeholderText="--:-- --"
                                minDate={new Date('01-01-1000')}
                                maxDate={new Date('12-31-9999')}
                                showTimeSelect
                                showTimeSelectOnly
                                selected={this.state.startTime ? Date.parse(moment(this.state.startTime, 'h:mm aa').toISOString()) : null}
                                dateFormat="h:mm a"
                                onChange={(e) => {
                                    this.handleDateOnChange(e, 'startTime')
                                    if(e.toString().includes(this.props.selectedPod?.StartTime)){
                                        this.removeFieldFromPopUp("Start Time")
                                    } else if(!this.state.podDataChanged.includes('Start Time')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'Start Time']})
                                    }
                                }}
                            />
                        )}
                        {buildRow("End Time",
                            <DatePicker
                                placeholderText="--:-- --"
                                minDate={new Date('01-01-1000')}
                                maxDate={new Date('12-31-9999')}
                                showTimeSelect
                                showTimeSelectOnly
                                selected={this.state.endTime ? Date.parse(moment(this.state.endTime, 'h:mm aa').toISOString()) : null}
                                dateFormat="h:mm a"
                                onChange={(e) => {
                                    this.handleDateOnChange(e, 'endTime')
                                    if(e.toString().includes(this.props.selectedPod?.EndTime)){
                                        this.removeFieldFromPopUp("End Time")
                                    } else if(!this.state.podDataChanged.includes('End Time')){
                                        this.setState({podDataChanged: [...this.state.podDataChanged, 'End Time']})
                                    }
                                }}
                            />
                        )}
                        {buildRow("Nickname (internal only)",
                            <input  className="form-control"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        this.setState({nickName:e.target.value})
                                        if(e.target.value === this.props.selectedPod?.Nickname){
                                            this.removeFieldFromPopUp("Nickname")
                                        } else if(!this.state.podDataChanged.includes('Nickname')){
                                            this.setState({podDataChanged: [...this.state.podDataChanged, 'Nickname']})
                                        }
                                    }}
                                    value={this.state.nickName}
                                    maxLength={200}
                            />)
                        }

                        {/* Custom Field Data  */}

                        {this.props.pageCustomQuestions.map((val, index) => {
                            if(val.Options.isActive){
                                return (
                                    <div className="col-12 p-0">
                                        <div className="form-group row">
                                            <GetField 
                                            val={val} 
                                            selectedItem={this.state.selectedPod ? this.state.selectedPod : {}} 
                                            handleChange={(e) => {
                                                this.setState({
                                                    customFieldData: e.CustomFieldData, selectedPod: e
                                                })
                                            }}  
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        })}

                        <h5 className="text-center text-md-left">Scheduled Breaks</h5>
                        <div className="row">

                            {/* tablets and desktop  */}
                            <div className="col-12 d-none d-md-block">
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th scope="col">Start</th>
                                        <th scope="col">End</th>
                                    </tr>
                                    </thead>
                                    {this.state.breaks.map((b, index) =>{
                                        return (
                                            <tr>
                                                <td>{moment(b.StartTime).format('h:mm a')}</td>
                                                <td>{moment(b.EndTime).format('h:mm a')}</td>
                                                <td>
                                                    <button className={"btn immyClearButtonOutline"} onClick={() => {
                                                        this.deleteBreak(index)
                                                        if(!this.state.podDataChanged.includes('Deleted Break')){
                                                            this.setState({podDataChanged: [...this.state.podDataChanged, 'Deleted Break']})
                                                        }
                                                    }}>Delete</button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    <tr>
                                        <td>
                                            <DatePicker
                                                
                                                placeholderText="--:-- --"
                                                minDate={new Date('01-01-1000')}
                                                maxDate={new Date('12-31-9999')}
                                                disabled={!this.state.startTime || !this.state.endTime}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                selected={this.state.breakStartSelector ? Date.parse(moment(this.state.breakStartSelector, 'h:mm a').toISOString()) : null}
                                                dateFormat="h:mm a"
                                                onChange={(e) => {
                                                    this.handleDateOnChange(e, 'breakStartSelector')

                                                    if(e === null && (this.state.breakEndSelector === null || this.state.breakEndSelector === "")){
                                                        this.setState({breakChanged: 0})
                                                    } else {
                                                        this.setState({breakChanged: 1})
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                placeholderText="--:-- --"
                                                minDate={new Date('01-01-1000')}
                                                maxDate={new Date('12-31-9999')}
                                                disabled={!this.state.startTime || !this.state.endTime}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                selected={this.state.breakEndSelector ? Date.parse(moment(this.state.breakEndSelector, 'h:mm a').toISOString()) : null}
                                                dateFormat="h:mm a"
                                                onChange={(e) => {
                                                    console.error(e)
                                                    this.handleDateOnChange(e, 'breakEndSelector')

                                                    if(e === null && (this.state.breakStartSelector === null || this.state.breakStartSelector === "")){
                                                        this.setState({breakChanged: 0})
                                                    } else {
                                                        this.setState({breakChanged: 1})
                                                    }

                                                }}
                                            />
                                        </td>
                                        <td>
                                            <button disabled={!this.state.startTime || !this.state.endTime} className={"btn immySubmitButtonOutline "} onClick={this.newBreak}>Add</button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>


                        {/* phone  */}
                        <div className="row d-block d-md-none">
                            <div className={this.state.breaks?.length > 0 ? "row d-flex justify-content-center border border-secondary rounded p-2" : "row"}>
                                {this.state.breaks.map((b, index) =>{
                                        return (
                                            <div className="row mt-1">
                                                <div className={"col-5"}>{moment(b.StartTime).format('h:mm a')}</div>
                                                <div className={"col-5"}>{moment(b.EndTime).format('h:mm a')}</div>
                                                <div className={"col-2"}><button className={"btn btn-sm immyClearButtonOutline"} onClick={() => this.deleteBreak(index)}>Delete</button></div>
                                            </div>
                                        )
                                    })}
                            </div>
                            <div className="row mt-2"> 
                                <div className="col-2">
                                    <label htmlFor="Start">Start</label>
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="End">End</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={"col-7"}>
                                    <DatePicker
                                        placeholderText="--:-- --"
                                        minDate={new Date('01-01-1000')}
                                        maxDate={new Date('12-31-9999')}
                                        disabled={!this.state.startTime || !this.state.endTime}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        selected={this.state.breakStartSelector ? Date.parse(moment(this.state.breakStartSelector, 'h:mm a').toISOString()) : null}
                                        dateFormat="h:mm a"
                                        onChange={(e) => this.handleDateOnChange(e, 'breakStartSelector')}
                                    />
                                    <div className="row">
                                        <div className="col-12">
                                            <DatePicker
                                                placeholderText="--:-- --"
                                                minDate={new Date('01-01-1000')}
                                                maxDate={new Date('12-31-9999')}
                                                disabled={!this.state.startTime || !this.state.endTime}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                selected={this.state.breakEndSelector ? Date.parse(moment(this.state.breakEndSelector, 'h:mm a').toISOString()) : null}
                                                dateFormat="h:mm a"
                                                onChange={(e) => this.handleDateOnChange(e, 'breakEndSelector')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <button disabled={!this.state.startTime || !this.state.endTime} className={"btn btn-sm immySubmitButtonOutline"} onClick={this.newBreak}>Add</button>

                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => {
                                if(this.state.breakChanged || (this.state.podDataChanged && this.state.podID > 0 && this.state.podDataChanged.length > 0)){
                                    return sweetalert.fire({
                                        padding: '8px',
                                        icon: 'warning', 
                                        title: '', 
                                        html: this.state.breakChanged ? `<p>Are you sure you want to continue? There are breaks that have not been added yet. Please select the Add button to Add a break to this Schedule."</p>` : `<p>Please be sure to manually notify patients of the changes made to this schedule. Patients will NOT be notified automatically.</p>  <p>Changes:</p> ${this.state.podDataChanged.join('<br>')}`,
                                        showConfirmButton: true,
                                        showCancelButton: true,
                                        confirmButtonText: "Continue",
                                            }).then((result) => {
                                        if(result.isConfirmed){
                                            let formValidation = {
                                                Facility: this.state.facility,
                                                IsPrivate: this.state.isPrivate,
                                                IsActive: this.state.isActive,
                                                Factor: this.state.factor,
                                                Service: this.state.service,
                                                AccessCode: this.state.accessCode,
                                                Date: this.state.date,
                                                StartTime: this.state.startTime,
                                                EndTime: this.state.endTime,
                                            }
            
                                            let validator = new Validator<any>()
                                                .withSimpleValidation("Facility", Validators.requireNonNullValidator())
                                                .withSimpleValidation("IsActive", Validators.requireNonNullValidator("Active"))
                                                .withValidation("Factor", Validators.requireFactor(0, 100, "Appointment Per 5 Mins"))
                                                .withSimpleValidation("Service", Validators.requireNonNullValidator())
                                                .withSimpleValidation("IsPrivate", Validators.requireNonNullValidator("Private"))
                                                .withSimpleValidation("Date", Validators.requireNonNullValidator())
                                                .withSimpleValidation("StartTime", Validators.requireNonNullValidator("Start Time"))
                                                .withSimpleValidation("EndTime", Validators.requireNonNullValidator("End Time"))
                                            let validationResponse = validator.validate(formValidation);
                                            if(!validationResponse.success) {
                                                return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
                                            }
                                            if(Date.parse(this.state.date) < Date.parse(moment().set({'hour':0, 'minute': 0, 'second': 0}).toString())){
                                                console.log("NO")
                                                return sweetalert.fire({icon: 'error', title: '', text: "You cannot create a schedule in the past!"})
                                            }

                                            if(this.state.service && this.state.service.length < 1){
                                                return sweetalert.fire({icon: 'error', title: '', text: "At least one service must be chosen"});
                                            }
            
                                            if(this.state.isPrivate.value && !this.state.accessCode.trim()){
                                                return sweetalert.fire({icon: 'error', title: '', text: "Private schedules must have an access code"});
                                            }
                                            if(moment(this.state.startTime, "HH:mm") > moment(this.state.endTime, "HH:mm")){
                                                return sweetalert.fire({icon: 'error', title: '', text: "Start time cannot be before the end time"});
                                            }
            
                                            if(this.doesPodConflictWithBreak(this.state.startTime, 'startTime')){
                                                sweetalert.fire({icon: 'error', title: '', text: "Schedules can not start after the start of a break."});
                                            }
                                            if(this.doesPodConflictWithBreak(this.state.endTime, 'endTime')){
                                                sweetalert.fire({icon: 'error', title: '', text: "Schedules can not end before the end of a break."});
                                            }

                                            this.props.onSubmit({
                                                AccessCode: this.state.accessCode ? this.state.accessCode.trim() : "",
                                                Active: this.state.isActive.value,
                                                EndTime: moment(this.state.endTime).format("HH:mm:ss"),
                                                FacilityID: this.state.facility.value,
                                                Factor: this.state.factor,
                                                ID: this.state.podID === -1 ? null : this.state.podID, //-1 is no existing schedule, so make a new one
                                                Nickname: this.state.nickName ? this.state.nickName.trim() : "",
                                                Private: this.state.isPrivate.value,
                                                ServiceIDs: this.state.service && this.state.service.length > 0 ? this.state.service.map(a => a.value) : null,
                                                StartTime: moment(this.state.startTime).format("HH:mm:ss"),
                                                TestDate: this.state.date,
                                                CustomFieldData: this.state.customFieldData
                                            }, JSON.parse(JSON.stringify(this.state.breaks.map(b =>{
                                                return {StartTime:moment(b.StartTime).format('HH:mm:ss'), EndTime:moment(b.EndTime).format('HH:mm:ss')}
                                            }))))
                                        } else {
                                            return
                                        }
                                    })
                                }
                                let formValidation = {
                                    Facility: this.state.facility,
                                    IsPrivate: this.state.isPrivate,
                                    IsActive: this.state.isActive,
                                    Factor: this.state.factor,
                                    Service: this.state.service,
                                    AccessCode: this.state.accessCode,
                                    Date: this.state.date,
                                    StartTime: this.state.startTime,
                                    EndTime: this.state.endTime,
                                }

                                let validator = new Validator<any>()
                                    .withSimpleValidation("Facility", Validators.requireNonNullValidator())
                                    .withSimpleValidation("IsActive", Validators.requireNonNullValidator("Active"))
                                    .withValidation("Factor", Validators.requireFactor(0, 100, "Appointment Per 5 Mins"))
                                    .withSimpleValidation("Service", Validators.requireNonNullValidator())
                                    .withSimpleValidation("IsPrivate", Validators.requireNonNullValidator("Private"))
                                    .withSimpleValidation("Date", Validators.requireNonNullValidator())
                                    .withSimpleValidation("StartTime", Validators.requireNonNullValidator("Start Time"))
                                    .withSimpleValidation("EndTime", Validators.requireNonNullValidator("End Time"))
                                let validationResponse = validator.validate(formValidation);
                                if(!validationResponse.success) {
                                    return sweetalert.fire({icon: 'error', title: '', text: validationResponse.error});
                                }

                                if(this.state.service && this.state.service.length < 1){
                                    return sweetalert.fire({icon: 'error', title: '', text: "At least one service must be chosen"});
                                }
                                if(Date.parse(this.state.date) < Date.parse(moment().set({'hour':0, 'minute': 0, 'second': 0}).toString())){
                                    return sweetalert.fire({icon: 'error', title: '', text: "You cannot create a schedule in the past!"})
                                }
                                if(Date.parse(this.state.date) === Date.parse(moment().set({'hour':0, 'minute': 0, 'second': 0}).toString()) && Date.parse(this.state.startTime) < Date.parse(moment().toString())){
                                    return sweetalert.fire({icon: 'error', title: '', text: "You cannot create a schedule in the past! Please adjust Start Time before submitting"})
                                }
                                if(this.state.isPrivate.value && !this.state.accessCode.trim()){
                                    return sweetalert.fire({icon: 'error', title: '', text: "Private schedules must have an access code"});
                                }
                                if(moment(this.state.startTime, "HH:mm") > moment(this.state.endTime, "HH:mm")){
                                    return sweetalert.fire({icon: 'error', title: '', text: "Start time cannot be before the end time"});
                                }

                                if(this.doesPodConflictWithBreak(this.state.startTime, 'startTime')){
                                    return sweetalert.fire({icon: 'error', title: '', text: "Schedules can not start after the start of a break."});
                                }
                                if(this.doesPodConflictWithBreak(this.state.endTime, 'endTime')){
                                    return sweetalert.fire({icon: 'error', title: '', text: "Schedules can not end before the end of a break."});
                                }

                                for(const podBreak of this.state.breaks){
                                    if(!this.isBreakValid(podBreak))
                                        return;
                                }


                                let invalid = CustomFieldBuilder.validateCustomFields(this.state.customFieldData, this.props.pageCustomQuestions, {CreatedDate: this.state.createdDate})

                                if(invalid){
                                    return;
                                }
                                this.props.onSubmit({
                                    AccessCode: this.state.accessCode ? this.state.accessCode.trim() : "",
                                    Active: this.state.isActive.value,
                                    EndTime: moment(this.state.endTime).format("HH:mm:ss"),
                                    FacilityID: this.state.facility.value,
                                    Factor: this.state.factor,
                                    ID: this.state.podID === -1 ? null : this.state.podID, //-1 is no existing schedule, so make a new one
                                    Nickname: this.state.nickName ? this.state.nickName.trim() : "",
                                    Private: this.state.isPrivate.value,
                                    ServiceIDs: this.state.service && this.state.service.length > 0 ? this.state.service.map(a => a.value) : null,
                                    StartTime: moment(this.state.startTime).format("HH:mm:ss"),
                                    TestDate: this.state.date,
                                    CustomFieldData: this.state.customFieldData
                                }, JSON.parse(JSON.stringify(this.state.breaks.map(b =>{
                                    return {StartTime:moment(b.StartTime).format('HH:mm:ss'), EndTime:moment(b.EndTime).format('HH:mm:ss')}
                                }))))
                            }}>
                                Submit
                            </button>
                        </div>
                    
                </div>
                </div>
            </div>
        </div>;
    }
}